export const WaterfallColors = {
  actualPositive: '#4CAF50',
  forecastPositive: '#81C784',
  subtotal: '#0078D4',
  actualNegative: '#D32F2F',
  forecastNegative: '#E57373',
  result: '#F9C635',
  connector: '#9CA9AF',
  xTickColor: '#4B5B63',
  yTickColor: '#9CA9AF',
  gridColor: '#E5E9EB'
}
